// extracted by mini-css-extract-plugin
module.exports = {"caret":"FormOrderDateAccordion_caret__ReNK0","headerContainer":"FormOrderDateAccordion_headerContainer__6_1_w","calendar":"FormOrderDateAccordion_calendar__O3nlS"};